<div class="portal-page-wrap">
    <iframe
        id="pwcIframeHideHeader"
        title="pwcIframeHideHeader"
        sandbox="allow-top-navigation allow-same-origin allow-scripts allow-forms allow-popups"
        [src]="pageUrl | trustAsResourceUrl"></iframe>
</div>
